import styled from 'styled-components';
import { media, spacing } from '~/theme';

export const ButtonConatiner = styled.div`
    display: flex;
    gap: ${spacing.spacing4};
    margin-top: ${spacing.spacing6};
    margin-bottom: ${spacing.spacing6};

    @media (max-width: 768px) {
        display: block;
    }
`;
export const StyledText = styled.div`
    width: 75%;
`;
export const TextStyle = styled.div`
    margin-top: ${spacing.spacing6};
`;
export const CardContainer = styled.div`
    margin-bottom: ${spacing.spacing1};
    p {
        margin-right: ${spacing.spacing4};
    }

    @media ${media.small} {
        display: flex;
    }
`;
